import React from "react";
import { Typography, Row, Col } from "antd";

const { Paragraph } = Typography;

const ProductDescription = ({
    allData,
    categoryName,
    classifiedDetail,
    convertHTMLToText,
    inv_title1,
    renderSpecification,
    selectedColorName,
    subCategoryName,
}) => {
    return (
        <>

            <Row gutter={[20, 20]}>
                <Col xs={{ span: 24 }} lg={{ span: 14 }}>
                    <h4 className='tabTitle'>Overview</h4>
                    <Paragraph className='description'>
                        {classifiedDetail.description ? convertHTMLToText(classifiedDetail.description) : ""}
                    </Paragraph>

                    <ul className='proList'>
                        {" "}
                        {classifiedDetail.condition && (
                            <li>
                                <strong>Condition:</strong>
                                <span>{classifiedDetail.condition}</span>
                            </li>
                        )}
                        {classifiedDetail.brand_name && (
                            <li>
                                <strong>Brand:</strong>
                                <span>{classifiedDetail.brand_name}</span>
                            </li>
                        )}
                        {categoryName && (
                            <li>
                                <strong>Department:</strong>
                                <span>{categoryName}</span>
                            </li>
                        )}
                        {subCategoryName && (
                            <li>
                                <strong>Category:</strong>
                                <span>{subCategoryName}</span>
                            </li>
                        )}
                        {selectedColorName && (
                            <li>
                                <strong>{inv_title1 && inv_title1}:</strong>
                                <span>{selectedColorName}</span>
                            </li>
                        )}
                        <li>
                            <strong>Size:</strong>
                            <span>S M L </span>
                        </li>
                        {classifiedDetail.has_dimension && (
                            <li>
                                <strong>Package Dimension (L x W x H):</strong>
                                <span>{`${classifiedDetail.length} x ${classifiedDetail.width} x ${classifiedDetail.height}`}</span>
                            </li>
                        )}
                        {classifiedDetail.has_weight && (
                            <li>
                                <strong>Package Weight:</strong>
                                <span>{`${classifiedDetail.weight} ${classifiedDetail.weight_unit}`}</span>
                            </li>
                        )}
                        {classifiedDetail.has_weight && (
                            <li>
                                <strong>Package Weight:</strong>
                                <span>{`${classifiedDetail.weight} ${classifiedDetail.weight_unit}`}</span>
                            </li>
                        )}
                        {allData && allData.spicification && renderSpecification(allData.spicification)}
                    </ul>
                </Col>
                <Col xs={{ span: 0 }} lg={{ span: 2 }}>
                    &nbsp;
                </Col>
                <Col xs={{ span: 0 }} lg={{ span: 8 }}>
                    {classifiedDetail && classifiedDetail.classified_image && classifiedDetail.classified_image.length > 0 && classifiedDetail.classified_image[0].full_name ? <img src={classifiedDetail && classifiedDetail.classified_image.length > 0 && classifiedDetail.classified_image[0].full_name && classifiedDetail.classified_image[0].full_name} alt='' style={{ width: "100%" }} /> : null}
                </Col>
            </Row>
        </>
    )
}

export default ProductDescription